import { usePostHog } from "posthog-js/react";
import type { UserDto } from "@reactive-resume/dto";

export const useEventTracking = () => {
  const posthog = usePostHog();

  const captureEvent = (eventName: string, properties?: Record<string, any>) => {
    if (posthog) {
      posthog.capture(eventName, properties);
    }
  };

  const identifyUser = (user: UserDto) => {
    if (posthog && !user.isAnonymous) {
      console.log("PostHog: Identifying user", user.id);
      posthog.identify(user.id, {
        email: user.email,
        name: user.name,
        username: user.username,
        locale: user.locale,
        provider: user.provider,
        plusUser: user.plusUser,
        emailVerified: user.emailVerified,
        twoFactorEnabled: user.twoFactorEnabled,
      });
    }
  };

  const resetUser = () => {
    if (posthog) {
      console.log("PostHog: Resetting user session");
      posthog.reset();
    }
  };

  const getCurrentDistinctId = (): string | undefined => {
    if (posthog) {
      return posthog.get_distinct_id();
    }
    return undefined;
  };

  return {
    captureEvent,
    identifyUser,
    resetUser,
    getCurrentDistinctId,
    posthog,
  };
};
